import { ajax } from '../ajax'


//、 授课-课中投票添加
export const reqSKVoteAdd = (paramets) => ajax(`/Questionnaire/JxInvestigationModel/investigationAdd`, paramets, 'post')

//、 授课-课中投票详情
export const reqSKVoteDetail = (paramets) => ajax(`/Questionnaire/JxInvestigationModel/listOptionsById`, paramets,)

//、 授课-课中投票获取投票选项
export const reqSKVoteOpts = (paramets) => ajax(`/Questionnaire/JxInvestigationModel/queryOption`, paramets,)




// WEBPACK FOOTER //
// ./src/api/give-course/vote.js